import { TimezoneGroupsSchema, type TimezoneGroups, type TimezoneOption } from '@/schemas/timezone';
import type { Result } from '@/types/api-routes';
import { API_ROUTES, validatedApiRequest } from '@/types/api-routes';

class TimezoneService {
  private cache: TimezoneGroups | null = null;

  async getTimezones(): Promise<Result<TimezoneGroups>> {
    if (this.cache) {
      return { ok: true, data: this.cache };
    }

    const result = await validatedApiRequest(API_ROUTES.timezones, TimezoneGroupsSchema);
    if (result.ok) {
      this.cache = result.data;
    }
    return result;
  }

  async getFlatList(): Promise<Result<TimezoneOption[]>> {
    const result = await this.getTimezones();
    if (!result.ok) {
      return result;
    }

    const flat: TimezoneOption[] = [];
    Object.values(result.data).forEach(timezones => {
      flat.push(...timezones);
    });

    return { ok: true, data: flat };
  }

  async searchTimezone(query: string): Promise<Result<TimezoneOption | null>> {
    const result = await this.getFlatList();
    if (!result.ok) {
      return result;
    }

    const lowerQuery = query.toLowerCase();
    const found =
      result.data.find(
        tz => tz.value.toLowerCase().includes(lowerQuery) || tz.label.toLowerCase().includes(lowerQuery),
      ) || null;

    return { ok: true, data: found };
  }

  clearCache(): void {
    this.cache = null;
  }
}

export const timezoneService = new TimezoneService();

export { type TimezoneOption, type TimezoneGroups } from '@/schemas/timezone';
